import { restHelper } from "../../@common/service/api"

export interface Mosa {
  id: number
  name: string
  users?: {
    id: string
    email: string
    name: string
  }[]
}

export const queries = {
  mosaListWithUsers: `
    query {
      mosaListWithUsers {
        id
        name
        users {
          id
          email
          name
        }
      }
    }
  `,
}

export const mutations = {
  addUserToMosa: `
    mutation addUserToMosa(
      $mosaId: Int!
      $userId: Int!
    ) {
      addUserToMosa(
        mosaId: $mosaId
        userId: $userId
      ) {
        id
        name
        users {
          id
          email
          name
        }
      }
    }
  `,
  removeUserFromMosa: `
    mutation removeUserFromMosa(
      $mosaId: Int!
      $userId: Int!
    ) {
      removeUserFromMosa(
        mosaId: $mosaId
        userId: $userId
      ) {
        id
        name
        users {
          id
          email
          name
        }
      }
    }
  `,
  assignUserToMosa: `
    mutation assignUserToMosa(
      $mosaId: Int!
      $userId: Int!
    ) {
      assignUserToMosa(
        mosaId: $mosaId
        userId: $userId
      ) {
        id
        name
        users {
          id
          email
          name
        }
      }
    }
  `,
  attachCompaniesToSAR: `
    mutation attachCompaniesToSAR(
      $userId: Int!
      $companyIds: [Int]!
      $mosaId: Int!
    ) {
      attachCompaniesToSAR(
        userId: $userId
        companyIds: $companyIds
        mosaId: $mosaId
      )
    }
  `,
  detachCompaniesFromSAR: `
    mutation detachCompaniesFromSAR(
      $userId: Int!
      $companyIds: [Int]!
    ) {
      detachCompaniesFromSAR(
        userId: $userId
        companyIds: $companyIds
      )
    }
  `,
}

export const getMosaListWithUsers = restHelper<Mosa[], object>(
  queries,
  "mosaListWithUsers",
)

export const addUserToMosa = restHelper<
  Mosa,
  { mosaId: number; userId: number }
>(mutations, "addUserToMosa")

export const removeUserFromMosa = restHelper<
  Mosa,
  { mosaId: number; userId: number }
>(mutations, "removeUserFromMosa")

export const assignUserToMosa = restHelper<
  Mosa,
  { mosaId: number; userId: number }
>(mutations, "assignUserToMosa")

export const attachCompaniesToSAR = restHelper<
  boolean,
  { userId: number; companyIds: number[]; mosaId: number }
>(mutations, "attachCompaniesToSAR")

export const detachCompaniesFromSAR = restHelper<
  boolean,
  { userId: number; companyIds: number[] }
>(mutations, "detachCompaniesFromSAR")
